{
  "migrant-handbook": {
    "title": "Migrant Handbook - MAJORITY",
    "description": "Check out the MAJORITY community, with tons of articles on saving money and building wealth in the US, plus cool events and more!",
  
    "hero": {
      "title": "Migrant handbook",
      "body": "Download the free comprehensive guide to thriving in the United States and learn everything you need to know about life in the US.",
      "disclaimer": "To learn more about how we collect and use your information, see our <a class=\"{variant}\" href=\"{privacy_policy_link}\">privacy policy</a>",
      "cta": "Download now",
      "success": {
        "title": "THANK YOU!",
        "body": "Thanks for downloading the Migrant Handbook! It will arrive shortly in your inbox. We wish you well on your journey in the US."
      }
    },
  
    "list": {
      "title": "WHAT’S INSIDE",
      "items": [
        {
          "label": "CHAPTER",
          "title": "VISAS",
          "body": "Whether you come to the US for love, work, or studies, the journey starts with a visa. Learn more about the different types of visas, the fees, how to renew a visa, and more.",
          "button": "Download now"
        },
        {
          "label": "CHAPTER",
          "title": "SSN and ITIN",
          "body": "It’s hard to open a bank account, rent an apartment, and much more without a Social Security Number (SSN) or Individual Taxpayer Identification Number (ITIN). Download to find out more about SSNs and ITINs and how to apply for one.",
          "button": "Download now"
        },
        {
          "label": "CHAPTER",
          "title": "Housing",
          "body": "After you have arrived in the US, you’ll need a place to call home. Whether you are looking for an apartment to rent or ready to buy your first home, we’ll take you through the basics.",
          "button": "Download now"
        },
        {
          "label": "CHAPTER",
          "title": "Healthcare",
          "body": "Need a check-up or a medical procedure? At some point you’ll need to use the US healthcare system. If you know the basics, you’ll be able to get the care you need! Download to learn more.",
          "button": "Download now"
        },
        {
          "label": "CHAPTER",
          "title": "Banking",
          "body": "It will be hard to establish yourself in the US without a bank account. You will need it to pay bills, get paid, do a tax return, and more. Download the handbook to find out everything you need to know.",
          "button": "Download now"
        },
        {
          "label": "CHAPTER",
          "title": "Working",
          "body": "Need to know more about finding a job and working in the US? We’ll guide you through how to make it in the US job market.",
          "button": "Download now"
        },
        {
          "label": "CHAPTER",
          "title": "Education",
          "body": "All across the US, hallways and classrooms are packed with kids eager to learn. Learn more about the US education system and how to set your children up to succeed.",
          "button": "Download now"
        },
        {
          "label": "CHAPTER",
          "title": "Taxes",
          "body": "From the time they get their first jobs, most Americans begin filing taxes on a yearly basis. Don’t worry, the Migrant Handbook covers everything you need to know to file your own.",
          "button": "Download now"
        },
        {
          "label": "CHAPTER",
          "title": "Living in the US",
          "body": "For such a large country, it’s no surprise that the culture, food, people, and beliefs vary greatly from region to region. We’ll cover everything there is to know to get you started.",
          "button": "Download now"
        }
      ]
    }
  }
  
}